import { useTrackPageOnMount } from '../useTrackPageOnMount/useTrackPageOnMount'
import type { SignupInterestsEnum } from 'gql/types'

interface Params {
  step: string
  experiment?: string
  interestedIn: SignupInterestsEnum[]
}

export const useTrackOnboardingPageOnMount = ({ step, ...params }: Params): void => {
  useTrackPageOnMount(`Payer Onboarding. PageView. Step: ${step}`, params)
}
